import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-us-details',
  templateUrl: './about-us-details.component.html',
  styleUrls: ['./about-us-details.component.css']
})
export class AboutUsDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
